function prediction_roadflood(){
    // global參數
    let roadFloodList = {
            html: "",
            data: ajax_call(publicPath + "/napi/simulate/roadflood/list")
        },
        suppliesMovingPumpGeojson,
        townDetailedDict = {},
        movingPumpSpec = 0.3
    roadFloodList.data.forEach(el => {
        roadFloodList.html += `<option value="${el.predict_ts}">${el.time.slice(0,16)}</option>`
    })
    loader_asynchronous(function(){
        layer_table_redraw();
        if (!disable_map_clear) $("#map_clear").click();
        backgroud_layer_control("NCDR歷史淹水範圍(109~113年)");
        backgroud_layer_control("NCDR歷史淹水點位(109~113年)");
    });


    // 
    $("#map_clear").click()
	if ($("#legend_tag_地面淹水預測").length == 0) {
		$("#legend_div_container").append(`<div class="mb-1 legend_text" id="legend_tag_地面淹水預測"> 淹水深度<br> <img src="${publicPath}/cloud/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=30&STRICT=false&style=edp4:ntu2d_depth" width="100%"> </div>`);
	}
	$("#prediction_roadflood").html(`
        <div class="pr-2" style="height: calc( 100vh - 115px );">  
            <h5 class="font-weight-bold mb-0"><i class="fas fa-info-circle mr-2"></i>地面淹水預測&抽水機調度模組說明</h5>
            <h6 class="text-justify mt-1">為整合本系統降雨預測模組以及高解析度台大二維淹水模式，可於每10分鐘預測未來3小時可能的淹水深度與範圍，本模組將提供各行政區淹水示警村里統計結果，以供地面淹水災情預判情資參考。最後結合估算的淹水量體以及即時抽水機位置，可依據使用者設定的抽水時限，計算出抽水時間以及建議佈署抽水機數量，可供區域移抽調度參考。</h6>
            <div class="input-group mb-2"> 
                <div class="input-group-prepend"> 
                    <span class="input-group-text">預報時間選擇</span> 
                </div> 
                <select class="form-control" id="roadflood-prediction-report-selector">
                    ${roadFloodList.html}
                </select>
            </div>
            <div class="input-group mb-2"> 
                <div class="input-group-prepend"> 
                    <span class="input-group-text">預報結果檢視</span> 
                </div> 
                <select class="form-control" id="roadflood-prediction-report-timeindex-selector">
                    <option value="1">第1小時</option>
                    <option value="2">第2小時</option>
                    <option value="3">第3小時</option>
                </select>
            </div>
            <button type="button" class="btn btn-success btn-sm btn-block mt-2" id="roadflood-prediction-report-trig">查詢</button>
            <hr>
            <div id="roadflood-prediction-content"></div>
        </div>`
    )
    // 
    $("#roadflood-prediction-report-trig").click(function(){
        // 
        $("#base_layer .leaflet-layerstree-children").find("input").eq(5).click()
        suppliesMovingPumpGeojson = turf.featureCollection([])
        backgroud_layer_control("移動抽水機")
        // 
        let param = {
            predict_ts: $("#roadflood-prediction-report-selector").val(),
            predict_hour: $("#roadflood-prediction-report-timeindex-selector").val()
        }
        $("#roadflood-prediction-content").html(`
            <ul class="nav nav-tabs mt-10p" role="tablist">
                <li class="nav-item w-50 text-center">
                    <a class="nav-link active" data-toggle="tab" href="#roadflood-prediction-info-content" role="tab">淹水預測資訊</a>
                </li>
                <li class="nav-item w-50 text-center">
                    <a class="nav-link" data-toggle="tab" href="#roadflood-prediction-movingpump-content" role="tab">抽水機調度</a>
                </li>
            </ul>
            <div class="tab-content mt-2">
                <div class="tab-pane fade show active" role="tabpanel" id="roadflood-prediction-info-content">
                    <div class="card-body p-0">
                        <h5 class="font-weight-bold mb-0">
                            <i class="fas fa-chart-bar mr-2"></i>行政區示警統計情資
                            <button type="button" class="float-right btn btn-primary btn-sm mt-1 pt-0 pb-0 roadflood-prediction-content-reset">重設表格與地圖</button>
                        </h5>
                        <div class="mt-1" id="roadflood-prediction-content-town"><div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div></div>
                        <hr>
                        <h5 class="font-weight-bold mb-2"><i class="fas fa-table mr-2"></i>示警村里統計清單</h5>
                        <div class="mt-1" id="roadflood-prediction-content-village"><div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div></div>
                    </div>
                </div>
                <div class="tab-pane fade" role="tabpanel" id="roadflood-prediction-movingpump-content">
                    <div class="card-body p-0">
                        <h5 class="font-weight-bold mb-0">
                            <i class="fas fa-sliders-h mr-2"></i>參數設定
                        </h5>
                        <div class="input-group mt-2 mb-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">抽水時限</span>
                            </div>
                            <input id="roadflood-prediction-movingpump-content-advise-time" type="text" class="form-control" value="60" placeholder="請填入時間(分鐘)">
                            <div class="input-group-append">
                                <span class="input-group-text">分鐘</span></div><div class="input-group-append">
                                <button class="btn btn-success btn-sm" type="button" id="roadflood-prediction-movingpump-content-compute-trig">重新計算</button>
                            </div>
                        </div>
                        <hr>
                        <div id="roadflood-prediction-movingpump-table-container">
                            <h5 class="font-weight-bold mb-1">
                                <i class="fas fa-table mr-2"></i>區域調度管理列表
                            </h5>
                            <div id="roadflood-prediction-movingpump-table"><div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div></div>
                        </div>
                        <div class="d-none" id="roadflood-prediction-movingpump-edit-container"></div>
                    </div>
                </div>
            </div>`
        )
        // 淹水地圖render
        if (overlay_dataset["roadflood-prediction-map"]) {
            map.removeLayer(overlay_dataset["roadflood-prediction-map"])
        }
        overlay_dataset["roadflood-prediction-map"] = L.tileLayer.wms(publicPath + '/cloud/geoserver/edp4/wms?',{
            layers: 'edp4:ntu2d_layer',
            transparent: true,
            format: 'image/png',
            maxZoom: 22,
            cql_filter: `predict_ts = '${param.predict_ts}' and predict_hour = ${param.predict_hour}`,
            pane: "high-zindex-wms-layer"
        }).addTo(map)
        // 行政區&村里頁面
        ajax_call_async(
            publicPath + `/napi/simulate/roadflood/town/${param.predict_ts}/${param.predict_hour}`,
            function(data){
                let townCodeString = renderTownPage({
                    reportInfo: param,
                    data: data
                })
                // 
                if (townCodeString !== "") {
                    ajax_call_async(
                        publicPath + `/napi/simulate/roadflood/village/${param.predict_ts}/${param.predict_hour}`,
                        function(data){
                            data = data.filter(el => {
                                return el.villname !== null
                            })
                            townDetailedDict = renderVillagePage(data)
                            renderPumpPageTable()
                        },
                        function(){
                            console.log(123)
                        }
                    )
                }
            },
            function(){
                console.log(123)
            }
        )
        // 抽水時限更改重新計算事件
        $("#roadflood-prediction-movingpump-content-compute-trig").click(function(){
            renderPumpPageTable()
        })
    })
    // 
    function renderTownPage(param){
        let townDict = {},
            townCodeString = ""
        param.data.forEach(el => {
            if (!townDict[el.townname]) {
                townCodeString += el.towncode + ","
                townDict[el.townname] = 0
            }
            townDict[el.townname] += 1
        })
        $("#roadflood-prediction-content-town").html(`
            <div class="card shadow-sm">
                <div class="card-body text-center">
                    ${param.reportInfo.predict_ts.split(".")[0].slice(0,16)} 未來${param.reportInfo.predict_hour}小時<br>
                    地面淹水示警統計結果
                    <hr class="m-2">
                    <h5 class="font-weight-bold m-0 text-danger">共${Object.keys(townDict).length}處行政區<span id="roadflood-prediction-content-town-village-number"></span></h5>
                </div>
            </div>
            <p class="text-muted mt-1">備註：點擊行政區長條圖，檢視區域淹水範圍分布</p>
            <div id="roadflood-prediction-content-town-chart-container"></div>`
        )
        return townCodeString
    }
    // 
    function renderVillagePage(data){
        let townDict = {},
            townVillCodeDict = {},
            townDetailedDict = {},
            chartDataContainer = {},
            villageTotalNumber = 0,
            html = {
                table: ""
            },
            depthGroupMapping = {
                "0": 0.3, "1": 1, "2": 2, "3": 3
            }
        data.forEach(el => {
            if (!townDict[el.townname]) {
                townDict[el.townname] = {}
            }
            if (!townDict[el.townname][el.villname]) {
                townDict[el.townname][el.villname] = {}
            }
            townDict[el.townname][el.villname][String(el.depth_group)] = el
        })
        Object.keys(townDict).forEach(eachTownKey => {
            let thisTownVillKeys = Object.keys(townDict[eachTownKey])
            villageTotalNumber += thisTownVillKeys.length
            chartDataContainer[eachTownKey] = { "point": thisTownVillKeys.length }
            townVillCodeDict[eachTownKey] = ""
            thisTownVillKeys.forEach(eachVillKey => {
                let thisVillInfo
                Object.keys(townDict[eachTownKey][eachVillKey]).forEach(eachDepthKey => {
                    if (!thisVillInfo) {
                        thisVillInfo = townDict[eachTownKey][eachVillKey][eachDepthKey]
                        thisVillInfo.volume = 0
                        townVillCodeDict[eachTownKey] += "'" + townDict[eachTownKey][eachVillKey][eachDepthKey].villcode + "',"
                    }
                    thisVillInfo.area += townDict[eachTownKey][eachVillKey][eachDepthKey].area
                    thisVillInfo.volume += townDict[eachTownKey][eachVillKey][eachDepthKey].area * depthGroupMapping[String(eachDepthKey)]
                })
                html.table += `
                    <tr target-town="${thisVillInfo.townname}" target-villcode="${thisVillInfo.villcode}">
                        <td>${thisVillInfo.townname}</td>   
                        <td>${thisVillInfo.villname}</td>
                        <td>${thisVillInfo.area}</td>
                        <td>${thisVillInfo.volume.toFixed(0)}</td>
                        <td>0.45</td>
                    </tr>`
                if (!townDetailedDict[thisVillInfo.townname]) {
                    townDetailedDict[thisVillInfo.townname] = {
                        townname: thisVillInfo.townname,
                        volume: 0,
                        area: 0,
                        deploy: 0,
                        supplies: 0,
                        estimated_time: 0,
                        advise: 0
                    }
                }
                townDetailedDict[thisVillInfo.townname].volume += thisVillInfo.volume
                townDetailedDict[thisVillInfo.townname].area += thisVillInfo.area
            })
        })
        $("#roadflood-prediction-content-town-village-number").html("、" + villageTotalNumber + "處村里")
        $("#roadflood-prediction-content-town-chart-container").html('<div id="roadflood-prediction-content-town-chart" class="h-350 mt-2"></div>')
        // 行政區地圖
        if (overlay_dataset["roadflood-prediction-town-map"]) {
            map.removeLayer(overlay_dataset["roadflood-prediction-town-map"])
        }
        overlay_dataset["roadflood-prediction-town-map"] = L.geoJson(overlay_dataset["Basic_map"], {
            filter: function(feature){
                return Object.keys(townDict).includes(feature.properties["TOWNNAME"])
            },
            style: function(feature){
                return { 
                    fillColor: "red", 
                    weight: 1, 
                    color: "white",
                    opacity: 1, 
                    fillOpacity: 0.4 
                }
            },
            onEachFeature: function(feature, layer){
                layer.bindTooltip(feature.properties["TOWNNAME"] + "<br>達" + chartDataContainer[feature.properties["TOWNNAME"]].point + "處村里淹水示警", {
                    sticky: true,
                    opacity: 1
                })
            }
        }).addTo(map).on("click", function(e){
            let thisTown = e.layer.feature.properties["TOWNNAME"]
            zoomToRegionMap(thisTown)
            townLayer("close")
            villLayer("open", thisTown)
            if ($("#roadflood-prediction-movingpump-content").hasClass("active show")) {
                renderEditPage(thisTown)
            }
        })
        // 表格資訊
        $("#roadflood-prediction-content-village").html(`
            <table class="table table-sm table-pointer w-100 text-center">
                <thead class="thead-dark">
                    <tr>
                        <th rowspan="2">行政區</th>
                        <th rowspan="2">村里名</th>
                        <th colspan="3">淹水統計資訊</th>
                    </tr>
                    <tr>
                        <th>面積(m<sup>2</sup>)</th>
                        <th>體積(m<sup>3</sup>)</th>
                        <th>平均深度(m)</th>
                    </tr>
                </thead>
                <tbody>
                    ${html.table}
                </tbody>
            </table>`
        )
        let tableVill = $("#roadflood-prediction-content-village table").DataTable()
        $("#roadflood-prediction-content-village table").on("click", "tr", function(){
            zoomToRegionMap($(this).attr("target-town"))
            townLayer("close")
            villLayer("open", $(this).attr("target-town"))
            ajax_call_async(
                publicPath + "/cloud/geoserver/taiwan/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=taiwan%3Avillage_w84&outputFormat=application%2Fjson&cql_filter=VILLCODE=%27" + $(this).attr("target-villcode") + "%27",
                function(data){
                    map.fitBounds(L.geoJSON(data).getBounds())
                }
            )
        })
        // 
		stacked_chart({
			div: "roadflood-prediction-content-town-chart",
			data: [chartDataContainer],
			key_name: ["point"],
			label: ["示警村里數"],
			color: ["red"],
			stackingType: "normal",
			yAxisLabel: "處",
			legend: true,
			title: "各行政區地面淹水示警村里長條圖",
			click_event_binding: function(trigger_input){
				let query_condition = trigger_input
                tableVill.search(query_condition).draw()
                // 
                zoomToRegionMap(query_condition)
                townLayer("close")
                villLayer("open", query_condition)
			}
		})
        // 
        $("#roadflood-prediction-content").off()
        $("#roadflood-prediction-content").on("click", "button.roadflood-prediction-content-reset", function(){
            tableVill.search("").draw()
            $("#home_view").click()
            townLayer("open")
            villLayer("close")
        })
        // 
        function townLayer(action){
            if (overlay_dataset["roadflood-prediction-town-map"]) {
                map.removeLayer(overlay_dataset["roadflood-prediction-town-map"])
            }
            if (action === "open") {
                overlay_dataset["roadflood-prediction-town-map"].addTo(map)
            }
        }
        function villLayer(action, query_condition){
            if (overlay_dataset["roadflood-prediction-village-map"]) {
                map.removeLayer(overlay_dataset["roadflood-prediction-village-map"])
            }
            if (action === "open") {
                overlay_dataset["roadflood-prediction-village-map"] = L.tileLayer.wms(publicPath + '/cloud/geoserver/taiwan/wms?',{
                    layers: 'taiwan:village_w84',
                    transparent: true,
                    format: 'image/png',
                    maxZoom: 22,
                    cql_filter: `COUNTYNAME = '新北市' and VILLCODE IN (${townVillCodeDict[query_condition].slice(0,townVillCodeDict[query_condition].length-1)})`,
                    pane: "high-zindex-wms-layer"
                }).addTo(map)
            }
        }
        // 
        return townDetailedDict
    }
    // 抽水機調度頁面
    function renderPumpPageTable(){
        let tbodyList = [],
            suppliesMovingPumpGeojson = turf.featureCollection([])
        if (overlay_dataset["roadflood-movingpump-edit-supplies-layer"]) {
            suppliesMovingPumpGeojson = overlay_dataset["roadflood-movingpump-edit-supplies-layer"].toGeoJSON()
        }
        // 目前佈署
        if (raw_data["移動抽水機"]) {
            raw_data["移動抽水機"].forEach(el => {
                let nowMovingPumpBelongRegion = el._town
                if (Object.keys(townDetailedDict).includes(nowMovingPumpBelongRegion)) {
                    townDetailedDict[nowMovingPumpBelongRegion].deploy += 1    
                }
            })
        }
        // 表格矩陣
        Object.values(townDetailedDict).forEach(el => {
            el.supplies = 0
            // 區域新增移抽數量加總
            let thisTownSuppliesFeature = suppliesMovingPumpGeojson.features.filter(feature => {
                return feature.properties.townname === el.townname
            })
            thisTownSuppliesFeature.forEach(feature => {
                el.supplies +=  feature.properties.number
            })
            // 
            el.estimated_time = movingPumpDrainTime(el.volume, (el.deploy + el.supplies))
            el.advise = movingPumpNumberComputedText(el.deploy, el.supplies, (el.volume / movingPumpSpec / 60 / Number($("#roadflood-prediction-movingpump-content-advise-time").val())).toFixed(0))
            // 表格矩陣組裝
            tbodyList.push([el.townname, el.volume.toFixed(0), el.deploy, el.supplies, el.estimated_time, el.advise])
        })
        $("#roadflood-prediction-movingpump-table").html(`
            <ul>
                <li>操作說明：點擊任列，可對該行政區進行調度推演</li>
                <li>單位說明：體積(m<sup>3</sup>)、時間(分鐘)</li>
            </ul>
            <table class="table table-sm table-pointer table-hover w-100 text-center">
                <thead class="thead-dark">
                    <tr>
                        <th rowspan="2">區名</th>
                        <th rowspan="2">淹水體積</th>
                        <th colspan="2">移抽數</th>
                        <th rowspan="2">預估<br>抽水時間</th>
                        <th rowspan="2">建議增加<br>移抽數</th>
                    </tr>
                    <tr>
                        <th>現有</th>
                        <th>調度</th>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>`
        )
        $("#roadflood-prediction-movingpump-table table").DataTable({
            data: tbodyList,
            paging: false
        })
        $("#roadflood-prediction-movingpump-table table").on("click", "tr", function(){
            console.log(123)
            let thisTown = $(this).find("td").eq(0).html()
            for (let each in overlay_dataset["roadflood-prediction-town-map"]._layers) {
                if (overlay_dataset["roadflood-prediction-town-map"]._layers[each].feature.properties.TOWNNAME == thisTown) {
                    overlay_dataset["roadflood-prediction-town-map"].fire("click", { layer: overlay_dataset["roadflood-prediction-town-map"]._layers[each] })
                }
            }
        })
    }
    // 管理調度動作
    function renderEditPage(townname){
        $("#roadflood-prediction-movingpump-table-container").addClass("d-none")
        $("#roadflood-prediction-movingpump-edit-container").removeClass("d-none")
        $("#roadflood-prediction-movingpump-edit-container").html(`
            <h5 class="font-weight-bold mb-1">
                <i class="fas fa-table mr-2"></i>「${townname}」移動抽水機佈署
                <button id="roadflood-prediction-edit-reset" type="button" class="float-right btn btn-primary btn-sm mt-1 pt-0 pb-0 roadflood-prediction-content-reset">返回管理列表</button>
            </h5>
            <ul class="nav nav-tabs mt-10p" role="tablist">
                <li class="nav-item w-50 text-center">
                    <a class="nav-link active" data-toggle="tab" href="#roadflood-prediction-movingpump-edit-container-supplies" role="tab">調度移抽資訊</a>
                </li>
                <li class="nav-item w-50 text-center">
                    <a class="nav-link" data-toggle="tab" href="#roadflood-prediction-movingpump-edit-container-deploy" role="tab">現有移抽資訊</a>
                </li>
            </ul>
            <div class="tab-content mt-2">
                <div class="tab-pane fade show active" role="tabpanel" id="roadflood-prediction-movingpump-edit-container-supplies">
                    <div class="card-body p-0">
						<h5 class="mb-2 mt-0 font-weight-bold"><i class="fas fa-sliders-h mr-2"></i>新增移動抽水機</h5>
						<div class="form-group mb-2">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">設定台數</span>
                                </div>
                                <input type="text" class="form-control roadflood-prediction-movingpump-edit-parameter" placeholder="請輸入台數" value="1" name="number">
                            </div>
                        </div>
						<div class="form-group mb-2">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">設定規格(抽水量)</span>
                                </div>
                                <select class="form-control roadflood-prediction-movingpump-edit-parameter" name="cms">
                                    <option value="0.3" selected>0.3cms</option>
                                </select>
                            </div>
						</div>
						<div class="form-group mb-0">
							<div class="input-group">
							  	<div class="input-group-prepend">
							    	<span class="input-group-text">經度</span>
							  	</div>
							  	<input type="text" class="form-control roadflood-prediction-movingpump-edit-parameter" disabled placeholder="由地圖點選" name="lng">
							  	<div class="input-group-prepend">
							    	<span class="input-group-text">緯度</span>
							  	</div>
							  	<input type="text" class="form-control roadflood-prediction-movingpump-edit-parameter" disabled placeholder="由地圖點選" name="lat">
							  	<div class="input-group-append">
							    	<button class="btn btn-primary btn-sm" type="button" id="roadflood-prediction-movingpump-edit-pump-supplies-map">開啟點選</button>
							  	</div>
							</div>
						</div>
						<p class="m-0">*註：請點擊於此行政區域範圍內</p>
						<button class="btn btn-success btn-sm btn-block mb-2 mt-2" type="button" id="roadflood-prediction-movingpump-edit-pump-supplies-add-trig">新增調度移抽</button>
						<hr class="m-0">
						<h5 class="mb-0 mt-2 font-weight-bold"><i class="fas fa-table mr-2"></i>已新增移動抽水機檢視列表</h5>
						<table class="w-100 table table-sm table-bordered table-hover table-pointer text-center mt-2">
							<thead class="thead-dark">
                                <tr>
                                    <th>#</th>
                                    <th>增加台數</th>
                                    <th>規格</th>
                                    <th>管理操作</th>
                                </tr>
                            </thead>
							<tbody></tbody>
						</table>
                    </div>
                </div>
                <div class="tab-pane fade" role="tabpanel" id="roadflood-prediction-movingpump-edit-container-deploy">
                    <div class="card-body p-0">
						<h5 class="mb-0 mt-2 font-weight-bold"><i class="fas fa-table mr-2"></i>現有抽水機檢視列表</h5>
						<table class="w-100 table table-sm table-bordered table-hover table-pointer text-center mt-2">
							<thead class="thead-dark">
                                <tr>
                                    <th>#</th>
                                    <th>名稱</th>
                                    <th>時間</th>
                                    <th>狀態</th>
                                </tr>
                            </thead>
							<tbody></tbody>
						</table>                        
                    </div>
                </div>
            </div>`
        )
        // 
        $("#roadflood-prediction-edit-reset").click(function(){
            $("#roadflood-prediction-movingpump-table-container").removeClass("d-none")
            $("#roadflood-prediction-movingpump-edit-container").addClass("d-none")
            clearMovingPumpTempPoint()
            map.off('click')
        })
        // 移抽地圖佈署點擊事件
        $("#roadflood-prediction-movingpump-edit-pump-supplies-map").click(function(){
            let thisStatus = $(this).html()
            if (thisStatus === "開啟點選") {
                toast_open(`請透過點擊圖面(${townname})以佈署抽水機。`)
                $(this).html("關閉點選").removeClass("btn-primary").addClass("btn-danger")
                map.addEventListener('click', function(event) {
                    let targetTownFeature = overlay_dataset["Basic_map"].features.filter(function(feature){ return feature.properties.TOWNNAME === townname }),
                        ptsWithin = turf.pointsWithinPolygon(turf.point([event.latlng.lng, event.latlng.lat]), turf.featureCollection(targetTownFeature))
                    if (ptsWithin.features.length !== 0) {
                        $('.roadflood-prediction-movingpump-edit-parameter[name="lng"]').val(event.latlng.lng.toFixed(5))
                        $('.roadflood-prediction-movingpump-edit-parameter[name="lat"]').val(event.latlng.lat.toFixed(5))
                        clearMovingPumpTempPoint()
                        overlay_dataset["roadflood-movingpump-edit-temp-point"] = L.marker([event.latlng.lat, event.latlng.lng]).addTo(map)
                    } else {
                        toast_open(`您點擊的點位於此行政區(${townname})範圍外！`)
                    } 
                })
            } else {
                $(this).html("開啟點選").removeClass("btn-danger").addClass("btn-primary")
                map.off('click')
            }
        })
        // 移抽佈署新增事件
        resetSuppliesMovingPumpPointAndTable(townname)
        $("#roadflood-prediction-movingpump-edit-pump-supplies-add-trig").click(function(){
            let param = {
                    townname: townname
                },
                booleanInsert = true
            $('.roadflood-prediction-movingpump-edit-parameter').each(function(){
                param[$(this).attr("name")] = Number($(this).val())
                if (isNaN(param[$(this).attr("name")]) || param[$(this).attr("name")] == 0) {
                    booleanInsert = false
                }
            })
            if (booleanInsert) {
                suppliesMovingPumpGeojson.features.push({
                    "type": "Feature",
                    "geometry": {
                          "type": "Point",
                          "coordinates": [param.lng, param.lat]
                    },
                    "properties": param
                })
                resetSuppliesMovingPumpPointAndTable(townname)
                renderPumpPageTable()
            } else {
                toast_open("輸入新增佈署抽水機錯誤。")
            }
        })
        // 移抽佈署刪除事件
        $("#roadflood-prediction-movingpump-edit-container-supplies table tbody").on("click", "button", function(){
            let thisFeatureId = Number($(this).attr("serial-id"))
            suppliesMovingPumpGeojson.features.splice(thisFeatureId, 1)
            resetSuppliesMovingPumpPointAndTable(townname)
            renderPumpPageTable()
        })
        // 移抽目前表格事件
        resetNowMovingPumpTable(townname)
        // 表格點擊zoom事件綁定
        $("#roadflood-prediction-movingpump-edit-container-supplies table tbody, #roadflood-prediction-movingpump-edit-container-deploy table tbody").on("click", "tr", function(){
            let thisFeatureCoor = [Number($(this).attr("lat")), Number($(this).attr("lon"))]
            map.setView(thisFeatureCoor, 16)
        })
    }
    // 其它模組函式
    function clearMovingPumpTempPoint(){
        if (overlay_dataset["roadflood-movingpump-edit-temp-point"]) {
            map.removeLayer(overlay_dataset["roadflood-movingpump-edit-temp-point"])
        }
    }
    function resetSuppliesMovingPumpPointAndTable(townname){
        // 圖層
        if (overlay_dataset["roadflood-movingpump-edit-supplies-layer"]) {
            map.removeLayer(overlay_dataset["roadflood-movingpump-edit-supplies-layer"])
        }
        overlay_dataset["roadflood-movingpump-edit-supplies-layer"] = L.geoJSON(suppliesMovingPumpGeojson).addTo(map)
        // 表格
        let thisTownTbody = "",
            index = 1
        suppliesMovingPumpGeojson.features.forEach((feature, featureId) => {
            if (feature.properties.townname === townname) {
                thisTownTbody += `
                    <tr serial-id="${featureId}" lon="${feature.properties.lng}" lat="${feature.properties.lat}">
                        <td>${index}</td>
                        <td>${feature.properties.number}</td>
                        <td>${feature.properties.cms}cms</td>
                        <td><button type="button" class="btn btn-sm btn-danger">刪除</button></td>
                    </tr>`
                index += 1                
            }
        })
        if (thisTownTbody === "") {
            thisTownTbody = '<tr><td colspan="4">此行政區目前無新增記錄</td></tr>'
        }
        $("#roadflood-prediction-movingpump-edit-container-supplies table tbody").html(thisTownTbody)
    }
    function resetNowMovingPumpTable(townname){
        let thisTownTbody = "",
            index = 1
        raw_data["移動抽水機"].forEach(el => {
            if (el._town === townname) {
                thisTownTbody += `
                    <tr lon="${el._lon}" lat="${el._lat}">
                        <td>${index}</td>
                        <td>${el._id}</td>
                        <td>${el.operateat}</td>
                        <td>${el._status}</td>
                    </tr>`
                index += 1
            }
        })
        if (thisTownTbody === "") {
            thisTownTbody = '<tr><td colspan="4">此行政區目前無移動抽水機佈署</td></tr>'
        }
        $("#roadflood-prediction-movingpump-edit-container-deploy table tbody").html(thisTownTbody)
    }
	function movingPumpDrainTime(volume, totalMovingPumpNumber){
		let result
		if (totalMovingPumpNumber > 0) {
			result = (volume / (movingPumpSpec * totalMovingPumpNumber) / 60).toFixed(0)
		} else {
			result = '無佈署'
		}
		return result
	}
	function movingPumpNumberComputedText(deploy, supplies, advice){
		var result
		if (advice > (deploy + supplies)) {
			result = '缺' + (advice - deploy - supplies) + '臺'
		} else {
			result = '已滿足'
		}
		return result
	}
}
